const getters = {
    name: state => state.user.username,
    org_area_id: state => state.user.org_area_id,
    parent_id: state => state.user.parent_id,
}

export default getters;
